import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Boxoutline from "../../../../../../../../media/images/icons/outline-box";
import LocationFill from "../../../../../../../../media/images/icons/location-fill";
import DownloadLikeLogin from "../../../../../../../../media/images/icons/download-likelogin";
import FerightInfo from "./FerightInfo";
import ArrowStepLeft from "../../../../../../../../media/images/icons/arrow-steps-register";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import useSWRMutation from "swr/mutation";

import { useNavigate } from "react-router-dom";
import { DotLoader } from "react-spinner-overlay";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../hooks/useRedux";
import { fetcherPost } from "../../../../../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../../../redux/features/snackbarSlice";
import CustomButton from "../../../../../../../components/CustomButton";

export interface IorderInfo {
  id: string;
  licenseNr: string;
  companyName: string;
  registrarsInfo: {
    insertDateTime: string;
  };
  goodsInfo: {
    name: string;
  };
  truckWeightTo: string;
  description: string;
  packageTypeInfo: {
    name: string;
  };
  goodsCost: string;
  senderInfo: {
    fullName: string;
  };
  senderAddress: {
    fullName: string;
    cityName: string;
    address: string;
    tel: string;
  };
  receiverAddress: {
    fullName: string;
    cityName: string;
    tel: string;
  };
  operatorInfo: {
    license: {
      insertDateTime: string;
    };
  };
}

export default function ActiveFeright() {
  const theme = useTheme();

  const { fullName } = useAppSelector((state) => state.user);

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const [orderInfo, setOrderInfo] = useState<IorderInfo>({
    id: "",
    companyName: "",
    registrarsInfo: {
      insertDateTime: "",
    },
    goodsInfo: {
      name: "",
    },
    truckWeightTo: "",
    description: "",
    packageTypeInfo: {
      name: "",
    },
    goodsCost: "",
    senderAddress: {
      cityName: "",
      address: "",
    },
    receiverAddress: {
      cityName: "",
    },
  } as IorderInfo);

  const {
    data: activeCargoInfo,
    trigger: getActiveCargo,
    isMutating: isgetActiveCargoMutting,
  } = useSWRMutation(
    [`/Nobat/GetNobatShipStatus`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {},
    }
  );

  const { trigger: getLicenseApi, isMutating: isgetLicenseMutting } =
    useSWRMutation(
      [
        `/Report/GetReportByName`,
        localStorage.getItem("access_token"),
        {
          responseType: "blob",
        },
      ],
      fetcherPost,
      {
        onSuccess: (data) => {
          const { jsonStr } = data;
          const url = window.URL.createObjectURL(new Blob([jsonStr]));
          const link = document.createElement("a");
          link.href = url;

          // نام فایل را تنظیم کنید (در اینجا به طور فرضی "report.pdf")
          link.setAttribute("download", "report.pdf");

          // لینک را به صفحه اضافه کنید و کلیک کنید
          document.body.appendChild(link);
          link.click();

          // لینک را از صفحه حذف کنید
          document.body.removeChild(link);
        },
      }
    );

  useEffect(() => {
    getActiveCargo({});
  }, []);

  useEffect(() => {
    if (activeCargoInfo) {
      const { id, registrarsInfo, licenseNr, operatorInfo } = activeCargoInfo;
      const {
        goodsInfo,
        truckWeightTo,
        description,
        packageTypeInfo,
        goodsCost,
        senderInfo,
        senderAddress,
        receiverAddress,
        companyName,
      } = activeCargoInfo.orderInfo;

      setOrderInfo({
        id,
        companyName,
        senderInfo,
        licenseNr,
        goodsInfo,
        description,
        goodsCost,
        packageTypeInfo,
        truckWeightTo,
        senderAddress,
        receiverAddress,
        operatorInfo,
        registrarsInfo: {
          insertDateTime: registrarsInfo[1].insertDateTime,
        },
      });
    }
  }, [activeCargoInfo]);

  return (
    <>
      {isgetActiveCargoMutting ? (
        <Box
          sx={{
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          <DotLoader color={theme.palette.primary.main} />
          <Typography>لطفا منتظر باشید...</Typography>
        </Box>
      ) : !activeCargoInfo ? (
        <Box
          sx={{
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          <Typography>در حال حاضر بار فعالی ندارید!</Typography>
        </Box>
      ) : (
        <Box
          sx={{
            mt: 3,
            backgroundColor: "background.default",
            borderRadius: "16px",
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
            padding: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              padding: "8px",
              borderColor: "bgColor.blueGrey100",
              borderWidth: "1px",
              borderStyle: "solid",
              borderRadius: "16px",
              backgroundColor: "bgColor.grey100",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "8px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "background.default",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "6px",
                    borderRadius: "8px",
                  }}
                >
                  <Boxoutline color={theme.palette.textColor.main} />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                  >
                    {orderInfo?.goodsInfo?.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "success.main",
                    }}
                  >
                    بارنامه صادرشده
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flexWrap: "wrap",
                  gap: "4px",
                  justifyContent: "end",
                }}
              >
                <Box
                  sx={{
                    borderColor: "info.main",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    backgroundColor: "background.default",
                    padding: "2px",
                    borderRadius: "6px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                    noWrap
                  >
                    {addCommas(orderInfo?.goodsCost!)}
                    ریال
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: "4px",
                    justifyContent: "end",
                  }}
                >
                  <Box
                    sx={{
                      borderColor: "info.main",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      backgroundColor: "background.default",
                      padding: "2px",
                      borderRadius: "6px",
                    }}
                  >
                    <Typography noWrap variant="body2">
                      {orderInfo?.truckWeightTo} تن
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      borderColor: "info.main",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      backgroundColor: "background.default",
                      padding: "2px",
                      borderRadius: "6px",
                    }}
                  >
                    <Typography noWrap variant="body2">
                      {orderInfo?.packageTypeInfo?.name!}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                mt: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "background.default",
                padding: "8px",
                borderRadius: "8px",
                borderColor: "info.main",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                  justifyContent: "center",
                }}
              >
                <LocationFill color={theme.palette.primary.main} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "primary.main",
                  }}
                >
                  {orderInfo?.senderAddress.cityName}
                </Typography>
              </Box>
              <ArrowStepLeft color={theme.palette.textColor.main} />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                  justifyContent: "center",
                }}
              >
                <LocationFill color={theme.palette.secondary.main} />
                <Typography
                  variant="body2"
                  sx={{
                    color: "secondary.main",
                  }}
                >
                  {orderInfo?.receiverAddress.cityName}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <CustomButton
              onClick={() => getLicenseApi({ input: "LicenseBill" })}
              title="دریافت فایل بارنامه"
              bgColor="success.main"
              fSize="14px"
              px="6px"
              py="4px"
              borderRadius="6px"
              icon2={<DownloadLikeLogin color={"#fff"} />}
            />
            <CustomButton
              title="دریافت فایل مجوز"
              bgColor="success.main"
              fSize="14px"
              px="6px"
              py="4px"
              borderRadius="6px"
              icon2={<DownloadLikeLogin color={"#fff"} />}
            />
          </Box>

          <FerightInfo {...orderInfo} />
        </Box>
      )}
    </>
  );
}
